"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const componentlibrary_1 = require("@emarketer/componentlibrary");
const UserRegistrationContext_1 = require("../../context/UserRegistrationContext");
const TaxonomyCheckbox = ({ label, value, onClick, analytics, id, name }) => {
    const { userData } = (0, UserRegistrationContext_1.useUserRegistration)();
    const handleCallback = (val, checked) => {
        onClick(val, checked === componentlibrary_1.CHECKBOXCHECKED);
    };
    return (react_1.default.createElement(componentlibrary_1.CheckboxWrapper, { label: label, value: value, callback: handleCallback, checked: userData?.industries?.includes(value) ? componentlibrary_1.CHECKBOXCHECKED : componentlibrary_1.CHECKBOXUNCHECKED, analytics: analytics, name: name, id: id }));
};
exports.default = TaxonomyCheckbox;
